import React from "react";
import Button from '@mui/material/Button';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NumbersIcon from '@mui/icons-material/Numbers';
import useIPDHook from "./ipdHooks";
import useDropDownHook from "./ipdDropdownHooks";
import useInsuranceTableHook from "../master/insurance/insuranceTableHook";
import { useLocation } from "react-router-dom";
import PatinetInfo from "../../components/PatientInfo/patientInfo";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import "./IpdRegister.scss";
import convert from "../../Helper/helper";

const initialState = {
    ipdNo: "",
    wardID: "",
    bedID: "",
    admissionDate: convert(new Date()),
    billingMode: "",
    dischargeStatus: 0,
    activeStatus: true,
    insuranceDetail: {
        insuranceID: "",
        packageID: "",
        cardID: "",
        cardNumber: "",
        cardIssueDate: "",
        cardExpiryDate: "",
        cardHolderName: "",
        membershipNumber: "",
        relationWithPatient: "",

    }
}
const IPDRegister = () => {
    const location = useLocation()
    const { handleIPDChange, ipdState, handleIPD, wardStatList, bedStatList,
        handleBlur, allowNumbersOnly, errors, handleGoBack, handleIPDRoute } = useIPDHook(initialState);
    const { cardDropVal, packageDropValState } = useDropDownHook();
    const { insuranceState } = useInsuranceTableHook();

    return (
        <div className="patient-recieve-fee">
            {location?.state === null ? null : <PatinetInfo rowData={location} />}
            <div className="mt-2 ml-4">
                <h4>Add IPD</h4>
                <div className="back-btn"
                    onClick={handleGoBack}
                >
                    <ArrowBackIcon className="arrow-color" />
                    <span
                        style={{ cursor: "pointer" }}
                        className="anchr-link header-text mt-3 mb-3"
                    >
                        {"Back"}
                    </span>
                </div>
            </div>
            <form className="needs-validation" novalidate>
                <div className="basic-info" >
                    <div className="row mt-3">
                        {/* <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">IPD*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><NumbersIcon /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={
                                            errors?.ipdNo ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="lname" placeholder="IPD Number"
                                        name="ipdNo"
                                        value={ipdState?.ipdNo}
                                        onChange={(e) => handleIPDChange(e, null, "")}
                                        onKeyDown={allowNumbersOnly}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.ipdNo}.
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="form-group col-md-6">
                            <label for="validationCustom03" className="control-label col-sm">Wards*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-id-card" aria-hidden="true"></i></div>
                                    </div>
                                    <select
                                        onBlur={handleBlur}
                                        className={
                                            errors?.wardID ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        selected={ipdState?.wardID}
                                        value={ipdState?.wardID}
                                        onChange={(e) => handleIPDChange(e, null, "")}
                                        required
                                        name="wardID"
                                    >
                                        <option></option>
                                        {
                                            wardStatList && wardStatList?.map((ele, ind) => (
                                                <option value={ele?.uniqueId}>{ele?.wardName}</option>
                                            ))
                                        }

                                    </select>
                                    <div class="invalid-feedback">
                                        {errors && errors?.wardID}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Beds*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-id-card" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <select
                                        onBlur={handleBlur}
                                        className={
                                            errors?.bedID ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        selected={ipdState?.bedID}
                                        value={ipdState?.bedID}
                                        onChange={(e) => handleIPDChange(e, null, "")}
                                        required
                                        name="bedID"
                                    >
                                        <option></option>
                                        {
                                            bedStatList && bedStatList?.map((ele, index) => (
                                                <option value={ele?.bedID} key={index}>{ele?.bedNumber}</option>
                                            ))
                                        }
                                    </select>
                                    <div class="invalid-feedback">
                                        {errors && errors?.bedID}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Admission Date*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><CalendarMonthIcon /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="date"
                                        required
                                        className={
                                            errors?.admissionDate ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="lname" placeholder="Admission Date"
                                        name="admissionDate"
                                        value={ipdState?.admissionDate}
                                        onChange={(e) => handleIPDChange(e, null, "")}
                                        max={new Date()?.toISOString()?.split("T")[0]}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.admissionDate}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Billing Mode</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    {/* <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={"form-control"}
                                        id="lname" placeholder="Billing Mode"
                                        name="billingMode"
                                        value={ipdState?.billingMode}
                                        onChange={(e) => handleIPDChange(e, null, "")}
                                    /> */}
                                    <select
                                        onBlur={handleBlur}
                                        className={
                                            errors?.billingMode ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        selected={ipdState?.billingMode}
                                        value={ipdState?.billingMode}
                                        onChange={(e) => handleIPDChange(e, null, "")}
                                        required
                                        name="billingMode"
                                    >
                                        <option></option>

                                        <option value={"Insurance"}>Insurance</option>
                                        <option value={"Cash"}>Cash</option>

                                    </select>
                                    <div class="invalid-feedback">
                                        {errors && errors?.bedID}.
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* insurance */}
                {ipdState?.billingMode === "Insurance" ? <>

                    <div className="mt-2 ml-4">
                        <h4>Insurance</h4>
                    </div>
                    <div className="insurance d-flex flex-wrap">
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Insurance*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><NumbersIcon /></div>
                                    </div>
                                    <select
                                        onBlur={handleBlur}
                                        className={
                                            errors?.insuranceDetail?.insuranceID ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        selected={ipdState?.insuranceDetail?.insuranceID}
                                        value={ipdState?.insuranceDetail?.insuranceID}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                        required
                                        name="insuranceID"
                                    >
                                        <option></option>
                                        {
                                            insuranceState && insuranceState?.map((ele) => (
                                                <option value={ele?.uniqueID}>{ele?.insuranceName}</option>
                                            ))
                                        }


                                    </select>
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.insuranceID}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Package*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><NumbersIcon /></div>
                                    </div>
                                    <select
                                        onBlur={handleBlur}
                                        className={
                                            errors?.insuranceDetail?.packageID ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        selected={ipdState?.insuranceDetail?.packageID}
                                        value={ipdState?.insuranceDetail?.packageID}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                        required
                                        name="packageID"
                                    >
                                        <option></option>
                                        {
                                            packageDropValState && packageDropValState?.map((ele) => (
                                                <option value={ele?.uniqueID}>{ele?.packageName}</option>
                                            ))
                                        }


                                    </select>
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.packageID}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Card*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><NumbersIcon /></div>
                                    </div>
                                    <select
                                        onBlur={handleBlur}
                                        className={
                                            errors?.insuranceDetail?.cardID ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        selected={ipdState?.insuranceDetail?.cardID}
                                        value={ipdState?.insuranceDetail?.cardID}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                        required
                                        name="cardID"
                                    >
                                        <option></option>
                                        {
                                            cardDropVal && cardDropVal?.map((ele) => (
                                                <option value={ele?.uniqueID}>{ele?.cardName}</option>
                                            ))
                                        }


                                    </select>
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.cardID}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Card Holder Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={
                                            errors?.insuranceDetail?.cardHolderName ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="cardHolderName" placeholder="Car Holder Name"
                                        name="cardHolderName"
                                        value={ipdState?.insuranceDetail?.cardHolderName}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.cardHolderName}.
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Card Number*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={
                                            errors?.insuranceDetail?.cardNumber ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="cardNumber" placeholder="Card Number"
                                        name="cardNumber"
                                        value={ipdState?.insuranceDetail?.cardNumber}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                        onKeyDown={allowNumbersOnly}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.cardNumber}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Card Issue Date*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="date"
                                        required
                                        className={
                                            errors?.insuranceDetail?.cardIssueDate ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="cardIssueDate" placeholder="Car Issue Date"
                                        name="cardIssueDate"
                                        value={ipdState?.insuranceDetail?.cardIssueDate}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.cardIssueDate}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Card Expiry Date*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="date"
                                        required
                                        className={
                                            errors?.insuranceDetail?.cardExpiryDate ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="cardExpiryDate" placeholder="Car Expiry Date"
                                        name="cardExpiryDate"
                                        value={ipdState?.insuranceDetail?.cardExpiryDate}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.cardExpiryDate}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Amount*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={
                                            errors?.insuranceDetail?.amount ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="amount" placeholder="Amount"
                                        name="amount"
                                        value={ipdState?.insuranceDetail?.amount}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                        onKeyDown={allowNumbersOnly}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.amount}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Membership Number*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={
                                            errors?.insuranceDetail?.membershipNumber ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="membershipNumber" placeholder="Membership Number"
                                        name="membershipNumber"
                                        value={ipdState?.insuranceDetail?.membershipNumber}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.membershipNumber}.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">RelationWith Patient*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i className="fa fa-money-bill" aria-hidden="true"></i></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={
                                            errors?.insuranceDetail?.relationWithPatient ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="relationWithPatient" placeholder="RelationWith Patientr"
                                        name="relationWithPatient"
                                        value={ipdState?.insuranceDetail?.relationWithPatient}
                                        onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                    />
                                    <div class="invalid-feedback">
                                        {errors && errors?.insuranceDetail?.relationWithPatient}.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </> : null}
                <div className="d-flex justify-content-end mr-4 mb-3">
                    <Button variant="outlined"
                        onClick={(event) => handleIPD(event, ipdState)}
                    >Submit</Button>
                </div>
            </form>
        </div>
    );
};

export default IPDRegister;